import { Loader2 } from "lucide-react";

// E1 — while new data for a changed range is loading, dim old numbers + spinner (never show stale numbers as current)
export default function StaleOverlay({ loading, children, testid = "stale-overlay", label = "更新中…" }) {
  return (
    <div className="relative" data-testid={testid} data-stale={loading ? "true" : "false"} aria-busy={loading}>
      <div className={loading ? "opacity-40 pointer-events-none select-none transition-opacity" : "transition-opacity"}>{children}</div>
      {loading && (
        <div className="absolute inset-0 flex items-start justify-center pt-6 z-10" data-testid={`${testid}-spinner`}>
          <span className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white/95 px-3 py-1 text-xs text-slate-600 shadow">
            <Loader2 className="h-3.5 w-3.5 animate-spin text-teal-600" /> {label}
          </span>
        </div>
      )}
    </div>
  );
}
